import { Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { FormattedMessage, FormattedPlural } from 'react-intl';
import { useSelector } from 'react-redux';
import PpsiBasicList from '../../../components/common/PpsiBasicList';
import { States } from '../../PpsiContainer/constants';
import { getPpsisWithFilter } from '../../PpsiContainer/selectors';

const AffectedPpsisContent = ({ data }) => {
  const { ppiId } = data;
  const filter = useMemo(
    () => ({ relatedToPpiId: ppiId, status: States.PUBLISHED }),
    [ppiId]
  );
  const affectedPpsis = useSelector(getPpsisWithFilter(filter));
  return (
    <>
      <p style={{ margin: 0 }}>
        <FormattedPlural
          value={affectedPpsis.size}
          one="ppi.publishAffectedPpsisText"
          other="ppi.publishAffectedPpsisTextPlural"
        >
          {formattedPlural => <FormattedMessage id={formattedPlural} />}
        </FormattedPlural>
      </p>
      <p>
        <FormattedPlural
          value={affectedPpsis.size}
          one="ppi.publishAffectedPpsisListText"
          other="ppi.publishAffectedPpsisListTextPlural"
        >
          {formattedPlural => <FormattedMessage id={formattedPlural} />}
        </FormattedPlural>
      </p>
      <PpsiBasicList ppsis={affectedPpsis} key="whereused" />
      <p style={{ marginBottom: 0 }}>
        <Typography variant="caption">
          <FormattedMessage id="ppi.publishAffectedPpsisNote" />
        </Typography>
      </p>
    </>
  );
};

export default AffectedPpsisContent;
